import React from "react";
import ProjectIndicatorsDto from "@/models/interfaces/dtos/indicators/project-indicators-dto.ts";
import PathElementDto from "@/models/interfaces/dtos/path-element-dto.ts";

export interface ProjectIndicatorsContextProps {
    isLoading: boolean;
    projectIndicatorsData: ProjectIndicatorsDto | undefined;

    filesPathData: PathElementDto[] | undefined;

    invalidateProjectIndicatorsData: () => Promise<void>,
    invalidateFilesPathData: () => Promise<void>
}

export const IndicatorsContext = React.createContext<ProjectIndicatorsContextProps | undefined>(undefined);